import React, { Children } from "react";
import PropTypes from "prop-types";
import { Row, Col, Form, Select, Input, Typography } from "antd";

import { Controller } from "react-hook-form";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text } = Typography;

const UpdateReportCategoryRow = ({
  showLabels,
  showMessage,
  reportCategories,
  index,
  control,
  remove,
}) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
      <div style={{ width: "300px", display: "inline-block" }}>
        <Form.Item
          label={showLabels && "Hotel"}
          labelCol={{ span: showLabels ? 24 : 0 }}
        >
          <Controller
            name={`reports.${index}.hotel_name`}
            control={control}
            render={({ field: { value } }) => {
              return <Input value={value} disabled />;
            }}
          />
        </Form.Item>
      </div>
      <div style={{ width: "300px", display: "inline-block" }}>
        <Form.Item
          label={showLabels && "Current Category"}
          labelCol={{ span: showLabels ? 24 : 0 }}
        >
          <Controller
            name={`reports.${index}.current`}
            control={control}
            render={({ field: { value } }) => (
              <Select
                style={{ width: "100%" }}
                placeholder="Report Category"
                allowClear
                mode="multiple"
                value={value}
                disabled
              >
                {reportCategories.map((category) => (
                  <Option key={category._id} value={category._id}>
                    {category.name}
                  </Option>
                ))}
              </Select>
            )}
          />
        </Form.Item>
      </div>
      <div style={{ width: "300px", display: "inline-block" }}>
        {/* {`reports.${index}.report_category`} */}
        <Form.Item
          label={showLabels && "New Category"}
          labelCol={{ span: showLabels ? 24 : 0 }}
          // style={{ width: "300px", display: "inline-block" }}
        >
          <Controller
            name={`reports.${index}.report_category`}
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Select
                placeholder="Report Category"
                allowClear
                mode="multiple"
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                showSearch
                optionFilterProp="children"
              >
                {reportCategories.map((category) => (
                  <Option key={category._id} value={category._id}>
                    {category.name}
                  </Option>
                ))}
              </Select>
            )}
          />
        </Form.Item>
      </div>
      <div style={{ width: "50px", display: "inline-block" }}>
        <Form.Item
          label={showLabels && " "}
          labelCol={{ span: showLabels ? 24 : 0 }}
        >
          <CloseOutlined
            style={{ color: "#CB1F1F" }}
            onClick={() => remove(index)}
          />
        </Form.Item>
      </div>
      {showMessage && (
        <div style={{ width: "300px", display: "inline-block" }}>
          <Form.Item
            label={showLabels && " "}
            labelCol={{ span: showLabels ? 24 : 0 }}
          >
            <Controller
              name={`reports.${index}.message`}
              control={control}
              render={({ field: { value } }) => {
                return <Text>{value}</Text>;
              }}
            />
          </Form.Item>
        </div>
      )}
    </div>
  );
};

UpdateReportCategoryRow.defaultProps = {
  showLabels: false,
  showMessage: false,
};

UpdateReportCategoryRow.propTypes = {
  showLabels: PropTypes.bool,
  showMessage: PropTypes.bool,
  index: PropTypes.number.isRequired,
};

export default UpdateReportCategoryRow;
